"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.FullHeight = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const prop_types_1 = __importDefault(require("prop-types"));
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const styles_1 = require("../../../styles");
const use_form_1 = __importStar(require("../../../form/use-form"));
exports.FullHeight = styled_1.default.div `
  min-height: 100%;
  display: flex;
  align-items: flex-end;

  & label {
    margin: 0;
    align-items: flex-start;
    text-indent: 0px;

    .checkmark {
      margin-right: 8px;
      flex: 14px 0 0;
    }
  }

  & span:not(.checkmark) {
    white-space: normal;
  }
`;
/**
 * Wrapper that allows Checkbox component to be used within Fields components
 *
 * @param {Object} path component props
 * @param {string} props.path path to data
 */
const CheckboxInput = ({ path }) => {
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (bool) => bool
    });
    const { AddOn, config } = state;
    const { context: { isRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    if (!config.isVisible)
        return null;
    return (react_1.default.createElement(exports.FullHeight, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: state.errors, style: { position: 'relative' } },
                react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!state.errors.length },
                    react_1.default.createElement(checkbox_1.default, { disabled: config.isReadOnly, hasError: !!state.errors.length, isRequired: config.isRequired, isRequiredMarker: isRequiredMarker, checked: state.value, name: name, label: config.label, onChange: (value) => {
                            config.isRequired && value === false
                                ? actions.onBlur('') // true is only value allowed when isRequired = true
                                : actions.onBlur(value);
                        }, dataTestId: path, "aria-describedby": `${config.path}-errors`, "aria-invalid": state.errors.length > 0 }))),
            react_1.default.createElement("div", { id: `${config.path}-errors` }, state.errors.map((error, index) => (react_1.default.createElement(styles_1.ErrorMessage, { key: `${error}-${index}` }, error)))),
            react_1.default.createElement(AddOn, null))));
};
CheckboxInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = CheckboxInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map